import React, { Suspense, memo, useContext, useEffect } from 'react';
import { Router, Switch } from 'react-router-dom';
import { getConfig } from '@olxeu-a2b/delivery-utils/src/extras';
import ErrorPage from '@olxeu-a2b/ui/src/commons/components/ErrorPage';
import LoadingSpinner from '@olxeu-a2b/ui/src/commons/components/LoadingSpinner';
import AuthRoute from '../utils/Components/AuthRoute';
import TemplateContext from '../contexts/TemplateContext';
import RoutesContext from './RoutesContext';

const {
  mweb: { url },
} = getConfig('sites');

const dynamicComponentFactory = (Component, route) =>
  memo(({ match, history: hstry }) => {
    const template = useContext(TemplateContext);
    const { setActive } = useContext(RoutesContext);

    useEffect(() => {
      setActive(route);
      if (route.templateInfo && !Object.is(template.templateInfo, route.templateInfo)) {
        const info =
          typeof route.templateInfo === 'function' ? route.templateInfo(match) : route.templateInfo;

        template.setInfoBlock(info);
      }

      if (route.onBack && !Object.is(template.onBack, route.onBack)) {
        template.setOnBack(route.onBack);
      }

      return () => {
        template.restoreDefault();
      };
    }, [match, route]);

    return (
      <Component
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...match.params}
        routePath={match.path}
        routeUrl={match.url}
        history={hstry}
      />
    );
  });

export default memo(({ history }) => {
  const { routes } = useContext(RoutesContext);

  return (
    <Suspense fallback={<LoadingSpinner delay={1000} />}>
      <Router history={history}>
        <Switch>
          {routes.map(route => {
            const { name, path, isPublic, Component } = route;
            return (
              <AuthRoute
                name={name}
                key={path}
                exact
                path={path}
                isPublic={isPublic}
                component={dynamicComponentFactory(Component, route)}
                history={history}
              />
            );
          })}
          <AuthRoute isPublic component={() => <ErrorPage status={404} homeUrl={url} />} />
        </Switch>
      </Router>
    </Suspense>
  );
});
